import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { DISTRIBUTIONS } from '../constants/distributions';
import { getChannelRoutingDistribution } from '../utils/distribution';
import RuleBox from './RuleBox';
import { jsx as _jsx } from "react/jsx-runtime";
export const DistributionSelect = ({
  channelType,
  disabled,
  distribution,
  onChange
}) => {
  const defaultDistribution = getChannelRoutingDistribution(channelType);

  // We place this logic here instead of `<RoutingRules />` to support this select
  // being rendered independently from the rest of the `<RoutingRules />` (a
  // skills-based routing use case)
  if (defaultDistribution !== DISTRIBUTIONS.RANDOM) {
    return null;
  }
  const getDistributionOptions = () => [{
    help: I18n.text('routing-ui.routingRules.distribution.method.balanced.help'),
    text: I18n.text('routing-ui.routingRules.distribution.method.balanced.label'),
    value: DISTRIBUTIONS.BALANCED
  }, {
    help: I18n.text('routing-ui.routingRules.distribution.method.random.help'),
    text: I18n.text('routing-ui.routingRules.distribution.method.random.label'),
    value: DISTRIBUTIONS.RANDOM
  }];
  return /*#__PURE__*/_jsx(RuleBox, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.routingRules.distribution.label"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      defaultOpen: false,
      disabled: disabled,
      options: getDistributionOptions(),
      menuWidth: 350,
      value: distribution,
      onChange: ({
        target
      }) => {
        // calling `setDistribution` this way for better typing
        onChange(target.value);
      },
      searchable: false
    })
  });
};
DistributionSelect.displayName = 'DistributionSelect';